import { LocationCardProps } from '@ahc-digital/component-library';
import { useI18n } from 'next-localization';
import { CreateLocationDataModel } from 'src/shared/LocationData.service';
import { getCheckbox, getDroplink } from 'src/shared/param-utils';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { C24LocationCardProps } from './C24LocationCard.types';
import { LayoutServicePageState, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { loadRuntimeConfig } from 'src/lib/runtime-config/loadRuntimeConfig';

const config = loadRuntimeConfig();

export function CreateLocationCardModel(props?: C24LocationCardProps): LocationCardProps {
  type t = LocationCardProps;
  const { fields, params } = props || {};
  const { t } = useI18n() || {};
  const { sitecoreContext } = useSitecoreContext();
  const { renderLink, renderImage } = useConditionalRendering();

  const imageOverlayPath = '/images/location-360.png';
  const publicUrl = (config.publicUrl || '').replace(/\/$/, '');

  const imageOverlayUrl =
    sitecoreContext.pageState === LayoutServicePageState.Normal
      ? imageOverlayPath
      : `${publicUrl}${imageOverlayPath}`;

  return {
    shouldDisplayImageOverlay: getCheckbox(params?.DisplayImageOverlay),
    animalIcon:
      fields?.AnimalIcon?.fields?.AnimalIcon && renderImage(fields.AnimalIcon.fields.AnimalIcon),
    firstCtaStyle: getDroplink<t['firstCtaStyle']>(params?.FirstCTAStyle, 'solid'),
    secondCtaStyle: getDroplink<t['secondCtaStyle']>(params?.SecondCTAStyle, 'link'),
    firstCta: renderLink(fields?.FirstCTA),
    secondCta: renderLink(fields?.SecondCTA),
    emergencyPhoneLabel: t('LocationCard-EmergencyPhoneNumber'),
    threeSixtyImage: <img src={imageOverlayUrl} height="72px" width="130px" alt="location-360" />,
    location: (fields?.Location?.fields && CreateLocationDataModel(fields.Location)) || {
      locationName: '',
      addressLine1: '',
    },
    shouldLazyLoad: getCheckbox(params?.ShouldLazyLoad),
  };
}
